import { Input, Row, noop } from '@iqueue/ui-kit'
import { useState, useEffect, useRef, useCallback, useMemo } from 'react'
import GLMap from '../map/GLMap'
import DrawControl from '../map/DrawControl'
import { Source, Layer } from 'react-map-gl'

const ICONS_BY_TYPE = {
  FIELD: 'water_pump',
  COLLECTION_POINT: 'oil_barrel',
  WELL: 'local_fire_department',
}

export default function PickPolygon({ nodes, name, value = {}, onChange, ...props }) {
  const [geoJSON, setGeoGSON] = useState(value)
  const mapRef = useRef(null)

  console.log(value, 'value')

  const fitToPolygon = useCallback((geoJSON) => {
    if (!mapRef.current) return
    const map = mapRef.current

    if (geoJSON?.features?.length) {
      const coordinates = geoJSON.features[0]?.geometry?.coordinates?.[0]
      if (coordinates) {
        const bounds = coordinates.reduce(
          (acc, [lng, lat]) => [
            Math.min(acc[0], lng),
            Math.min(acc[1], lat),
            Math.max(acc[2], lng),
            Math.max(acc[3], lat),
          ],
          [Infinity, Infinity, -Infinity, -Infinity],
        )

        map.fitBounds(bounds, {
          padding: 100,
          duration: 1000,
        })
        return
      }
    }

    if (nodes?.location) {
      const { lng, lat } = nodes.location
      map.flyTo({
        center: [lng, lat],
        zoom: 13,
        duration: 1000,
      })
    }
  }, [nodes])

  const features = useMemo(() => {
    const points = []
    const lines = []

    const walk = (node) => {
      if (!node?.location) return

      points.push({
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [node.location.lng, node.location.lat],
        },
        properties: {
          id: node.id,
          name: node.name,
          type: node.type,
          icon: ICONS_BY_TYPE[node.type] || 'corporate_fare',
        },
      })

      if (node.children?.length) {
        node.children.forEach((child) => {
          if (child.location) {
            lines.push({
              type: 'Feature',
              geometry: {
                type: 'LineString',
                coordinates: [
                  [node.location.lng, node.location.lat],
                  [child.location.lng, child.location.lat],
                ],
              },
              properties: {
                from: node.name,
                to: child.name,
                type: child.type,
              },
            })
          }
          walk(child)
        })
      }
    }

    walk(nodes)
    return {
      pointFeatures: {
        type: 'FeatureCollection',
        features: points,
      },
      lineFeatures: {
        type: 'FeatureCollection',
        features: lines,
      },
    }
  }, [nodes])

  const handleGeoJsonChange = useCallback((newGeoJson) => {
    setGeoGSON(newGeoJson)
    onChange(newGeoJson)
  }, [onChange])

  useEffect(() => {
    setGeoGSON(value)
  }, [])

  useEffect(() => {
    fitToPolygon(geoJSON)
  }, [])

  const pointFeatures = features.pointFeatures
  const lineFeatures = features.lineFeatures

  return <>
    <Row>
      <Input
        hidden
        size={ 12 }
        type={ 'raw' }
        name={ name }
        value={ geoJSON }
        serialize={ (v) => JSON.stringify(v) }
        deserialize={ (v) => JSON.parse(v) }
      />
    </Row>

    <div className={ 'pick-polygon-input-wrapper' }>
      <GLMap
        ref={ mapRef }
        id="pickPolygonMap"
        onGeolocate={ noop }
        onIdle={ noop }
        onLoad={ () => {
          const map = mapRef.current?.getMap()
          if (!map) return

          fitToPolygon(geoJSON)

          const icons = ['water_pump', 'oil_barrel', 'local_fire_department']
          icons.forEach((icon) => {
            if (map.hasImage(icon)) return

            const img = new Image(24, 24)
            img.onload = () => {
              if (!map.hasImage(icon)) {
                map.addImage(icon, img)
              }
            }
            img.onerror = () => console.warn(`Ошибка загрузки иконки ${ icon }`)
            img.src = `/response/${ icon }.png`
          })
        } }
      >

        <Source id="lines" type="geojson" data={ lineFeatures }>
          <Layer
            id="line-layer"
            type="line"
            paint={{
              'line-color': [
                'match',
                ['get', 'type'],
                'COLLECTION_POINT', '#FF6200',
                'WELL', '#A90637',
                '#cccccc'
              ],
              'line-width': 2,
            }}
          />
        </Source>
        <Source id="points" type="geojson" data={ pointFeatures }>
          <Layer
            id="point-circle-layer"
            type="circle"
            paint={ {
              'circle-radius': 14,
              'circle-color': [
                'match',
                ['get', 'type'],
                'FIELD', '#FF6200',
                'COLLECTION_POINT', '#A90637',
                'WELL', '#8C00FF',
                '#cccccc'
              ],
              'circle-stroke-color': '#FFFFFF',
              'circle-stroke-width': 2,
            } }
          />
          <Layer
            id="point-icon-layer"
            type="symbol"
            layout={ {
              'icon-image': ['get', 'icon'],
              'icon-size': 1,
              'icon-allow-overlap': true,
              'icon-anchor': 'center',
            } }
          />
        </Source>

        <DrawControl
          position={ 'top-left' }
          displayControlsDefault={ false }
          controls={ {
            polygon: true,
            trash: true,
          } }
          // defaultMode={ 'draw_polygon' }
          onChange={ handleGeoJsonChange }
          features={ geoJSON }
        />
      </GLMap>
    </div>
  </>
}
